import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select';
import i18n from '../../../i18n';
import { Fragment } from 'react';
import './Spinner.css'
import ProgressBar from './ProgressBar';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import ReactTooltip from 'react-tooltip';
import { useSelector } from 'react-redux'

export const Spinner = ({message}) => (
  <div style={{ textAlign: 'center' }}>
    <FontAwesomeIcon icon='circle-notch' size='3x' style={{ color: '#050139' }} spin />
    <div>
      <span> {message} </span>
    </div>
  </div>
);

export const SpinnerSmall = ({colour}) => (
  <div style={{ textAlign: 'center' }}>
    <FontAwesomeIcon icon='circle-notch' size='1x' style={{ color: colour }} spin />
  </div>
);

export const PerfTableLoading = () => {
  const today = new Date().toISOString().split('T')[0];
  const twentyYearsAgo = new Date();
  twentyYearsAgo.setFullYear(twentyYearsAgo.getFullYear() - 20);
  const dateTwentyYearsAgo = twentyYearsAgo.toISOString().split('T')[0];  
  return(
    <div>
      <div className='chartHeader'>{i18n.t('Daily NAV Performance')}</div>
      <div className='row' style={{ marginBottom: '20px' }}>
          <div className='col-md-3' style={{ textAlign: 'center', paddingRight: '3px' }}>
            <Select
              defaultValue={{ value: 'ror', label: 'Cumulative Total Return' }}
              options={[
                { value: 'ror', label: 'Cumulative Total Return' },
                { value: 'growth10k', label: 'Growth of 10K' },
              ]}
              onChange={(value) => console.log(value)}
            />
          </div>
          <div className='col-md-6' style={{ textAlign: 'center', paddingLeft: '3px', paddingRight: '3px' }}>
            <button className='dlyPerfbutton' onClick={() => console.log('mtd')}>MTD</button>
            <button className='dlyPerfbutton' onClick={() => console.log('qtd')}>QTD</button>
            <button className='dlyPerfbutton' onClick={() => console.log('ytd')}>YTD</button>
              <button className='dlyPerfbutton' onClick={() => console.log('1y')}>1Y</button>
              <button className='dlyPerfbutton' onClick={() => console.log('3y')}>3Y</button>
              <button className='dlyPerfbutton' onClick={() => console.log('5y')}>5Y</button>
              <button className='dlyPerfbutton' onClick={() => console.log('10y')}>10Y</button>
            <button className='dlyPerfbutton' style={{ borderRight: '1px solid #CCC' }} onClick={() => console.log('max')}>MAX</button>
          </div>
          <div className='col-md-3' style={{ textAlign: 'right', paddingLeft: '0px' }}>
            <div style={{ display: 'inline-block', verticalAlign: 'top', width: '90px', textAlign: 'right', paddingLeft: '3px' }}>
              <form>
                <input
                  name='startDate'
                  value={dateTwentyYearsAgo}
                  disabled
                  style={{ textAlign: 'center', paddingLeft: '5px', paddingRight: '5px', height: '38px', borderRadius: '0px' }}
                  className='form-control'
                />
              </form>
            </div>
            <div style={{ display: 'inline-block', verticalAlign: 'top', width: '20px', textAlign: 'center', lineHeight: '38px', color: '#5b6770', fontSize: '14px' }}>
              to
            </div>
            <div style={{ display: 'inline-block', verticalAlign: 'top', width: '90px', textAlign: 'right' }}>
              <form>
                <input
                  name='endDate'
                  disabled
                  value={today}
                  style={{ textAlign: 'center', paddingLeft: '5px', paddingRight: '5px', height: '38px', borderRadius: '0px' }}
                  className='form-control'
                />
              </form>
            </div>
            <div style={{ display: 'inline-block', verticalAlign: 'top', paddingLeft: '5px' }}>
            </div>
            <button className='dlyPerfGoButton' disabled >GO</button>                        
          </div>
        </div>
        <ProgressBar message={i18n.t('loading_performance')} />
    </div>
  )
}

export const GenTableLoading = ({title, message}) => {
  return(
    <Fragment>
      <ProgressBar message={message} />
    </Fragment>
  )
}

export const RenderAggandExposureHistory = () => {
  const aggReloadComplete = useSelector(state => state.fundData.aggReloadComplete)

    if (aggReloadComplete) {
        return null;
    }
    return (
        <div className='closeFundSelector'>
            <div style={{ position: 'relative', float: 'right', zIndex: 9999 }}>
                <button
                    className='getDataButton'
                    data-tip
                    data-for={`hover-tip-aggrefresh`}
                >
                    {<FontAwesomeIcon icon={faSpinner} spin />}
                </button>
                <ReactTooltip
                    key={`hover-tip-aggrefresh`}
                    id={`hover-tip-aggrefresh`}
                    type='light'
                    textColor='#5b6770'
                    arrowColor='transparent'
                    effect='float'
                    getContent={() => {
                        return null;
                    }}
                    multiline={true}
                >
                    {i18n.t('characteristics-refresh-primary')} <br />
                    {i18n.t('characteristics-refresh-secondary')}
                </ReactTooltip>
            </div>
        </div>
    );
};
